export function getProjectLang(args: {
  /** поддерживаемые языки */
  supportedLangs: string[];
  /** Входящий код языка. Может получаться из launchParams */
  inputLang: string;
  defaultLang: string;
  /** синонимы языков. Для того чтобы по разным языковым кодам отдавать нужные переводы */
  aliases?: { [key: string]: string };
}) {
  const { supportedLangs, inputLang, defaultLang, aliases } = args;
  const lang = inputLang ? aliases?.[inputLang] || inputLang : defaultLang;
  return supportedLangs.includes(lang) ? lang : defaultLang;
}

export function getLangDatingFileUrl(apiHttpUrl: string, lang: string, salt?: number) {
  const params = new URLSearchParams({ lang });

  if (salt) {
    params.append('salt', String(salt));
  }

  return `${apiHttpUrl}/config.langPack?${params}`;
}

/**
 * Получение языка из параметров запуска (ru, kz и т.д.)
 */
export const getLangFromLaunchParams = (launchParams: string) => {
  return new RegExp('vk_language=([a-z]+)').exec(launchParams)?.[1] || 'ru';
};

export async function loadLocalKeys() {
  try {
    // @ts-expect-error: TS2307
    const translations = await import('../cli/newTranslations.yaml');
    return translations.default;
  } catch {
    return {};
  }
}
